export function formatCSSVariablePrefix(prefix: string = 'diffs') {
  return `--${prefix}-`;
}
